export default "__VITE_ASSET__gjZi0v6l__"